import { render } from "./PlEditor.vue?vue&type=template&id=0b496411"
import script from "./PlEditor.vue?vue&type=script&lang=js"
export * from "./PlEditor.vue?vue&type=script&lang=js"

import "./PlEditor.vue?vue&type=style&index=0&id=0b496411&lang=less"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__